import React from 'react';
import { MagnifyingGlassIcon, LockClosedIcon } from '@heroicons/react/24/outline';

/**
 * Details step for PT Directory signups.
 * Uses contactEmail / contactFirstName / contactSurname / password / confirmPassword
 * from formData (same shape as VenueDetailsStep, minus venue fields).
 */
const PtDirectoryDetailsStep = ({
    formData,
    setFormData,
    emailValidationText,
    passwordValidationText
}) => {
    return (
        <div className="space-y-5">
            {/* Header */}
            <div className="flex items-center gap-3 p-4 bg-amber-500/5 border border-amber-500/20 rounded-lg">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MagnifyingGlassIcon className="h-5 w-5 text-amber-400" />
                </div>
                <div>
                    <p className="text-luxury-pearl font-semibold text-sm">PT Directory Account</p>
                    <p className="text-luxury-pearl/50 text-xs">
                        You'll be able to complete your profile (bio, specialisms, services) once signed up.
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">First Name *</label>
                    <input
                        type="text"
                        value={formData.contactFirstName || ''}
                        onChange={e => setFormData({ ...formData, contactFirstName: e.target.value })}
                        className="input-field"
                        placeholder="Your first name"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Surname *</label>
                    <input
                        type="text"
                        value={formData.contactSurname || ''}
                        onChange={e => setFormData({ ...formData, contactSurname: e.target.value })}
                        className="input-field"
                        placeholder="Your surname"
                    />
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Email Address *</label>
                <input
                    type="email"
                    value={formData.contactEmail || ''}
                    onChange={e => setFormData({ ...formData, contactEmail: e.target.value })}
                    className="input-field"
                    placeholder="your@email.com"
                />
                {emailValidationText && (
                    <p className="mt-1 text-sm text-red-400">{emailValidationText}</p>
                )}
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                    Password * <span className="text-gray-500 font-normal">(8–70 characters)</span>
                </label>
                <input
                    type="password"
                    value={formData.password || ''}
                    onChange={e => setFormData({ ...formData, password: e.target.value })}
                    className="input-field"
                    placeholder="Choose a strong password"
                    maxLength={70}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Confirm Password *</label>
                <input
                    type="password"
                    value={formData.confirmPassword || ''}
                    onChange={e => setFormData({ ...formData, confirmPassword: e.target.value })}
                    className="input-field"
                    placeholder="Confirm your password"
                    maxLength={70}
                />
                {passwordValidationText && (
                    <p className="mt-1 text-sm text-red-400">{passwordValidationText}</p>
                )}
            </div>

            <div className="flex items-start gap-2 p-3 bg-emerald-900/10 border border-emerald-700/30 rounded-lg text-xs text-emerald-300/70">
                <LockClosedIcon className="h-4 w-4 flex-shrink-0 mt-0.5" />
                <p>Your account is securely protected. Your password is encrypted and never stored in plain text.</p>
            </div>
        </div>
    );
};

export default PtDirectoryDetailsStep;


